import Error from 'components/Error';
import Loader from 'components/common-components/Loader';
import TabBody from 'components/tab-components/TabBody';
import TabHeader from 'components/tab-components/TabHeader';
import TabLayout from 'components/tab-components/TabLayout';
import React, { useEffect, useState } from 'react';
import UsersListHeader from './UsersListHeader';
import TableComponent from 'components/table-component/Table';
import { BlockedUsersTableHeader, CompanyUsersTableHeader, UsersTabsList } from './utils';
import { CallAPI } from 'actions/General';
import { useTranslation } from 'react-i18next';

const UsersList = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(UsersTabsList[0]);
  const [loader, setLoader] = useState(false);
  const [apiError, setApiError] = useState('');
  const [tableHeader, setTableHeader] = useState([]);
  const [users, setUsers] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filteringData, setFilteringData] = useState({});

  const getAllUsers = async (page = 1, limit = 10) => {
    if (selectedTab.value === 'users') {
      getAllCompaniesUsers(page, limit);
    } else {
      getBlockedUsers(page, limit);
    }
  };

  const getAllCompaniesUsers = async (page, limit) => {
    let result = await CallAPI(
      'GET_ALL_USERS',
      { ...filteringData, page, limit },
      null,
      setLoader,
      setApiError,
      null,
    );
    if (result.status) {
      const allUsers = result.data.userList.map((user) => ({
        ...user,
        companyName: user.company.companyName,
      }));

      setUsers(allUsers);
      if (page === 1) setTotalRecords(result.data.totalCount);
    }
  };

  const getBlockedUsers = async (page, limit) => {
    let result = await CallAPI(
      'GET_BLOCKED_USERS',
      { ...filteringData, page, limit },
      null,
      setLoader,
      setApiError,
      null,
    );
    if (result.status) {
      setUsers(result.data.userList);
      if (page === 1) setTotalRecords(result.data.totalCount);
    }
  };

  useEffect(() => {
    getAllUsers();
    setTableHeader(
      selectedTab.value === 'users' ? CompanyUsersTableHeader : BlockedUsersTableHeader,
    );
  }, [filteringData, selectedTab]);

  const translateValueFunc = (val) => t(val);

  return (
    <TabLayout>
      <TabHeader
        tabList={UsersTabsList}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        fixedWidth
      />
      <TabBody>
        {loader && <Loader color='green-1' type='modal-spinner' />}
        {apiError ? <Error msg={apiError} /> : <></>}
        <UsersListHeader filteringData={filteringData} setFilteringData={setFilteringData} />
        <TableComponent
          header={tableHeader}
          data={users}
          props={{
            actionsCallBack: getAllUsers,
            translateValueFunc: translateValueFunc,
            actionsType: selectedTab.value,
          }}
          totalRecords={totalRecords}
          loader={loader}
          isFieldSelectionEnabled={false}
          isPaginationEnabled={true}
          isActionsEnabled={true}
          paginationFunction={getAllUsers}
        />
      </TabBody>
    </TabLayout>
  );
};

export default UsersList;
